import { render, staticRenderFns } from "./Organ.vue?vue&type=template&id=4cf5ae88&scoped=true&"
import script from "./Organ.vue?vue&type=script&lang=js&"
export * from "./Organ.vue?vue&type=script&lang=js&"
import style0 from "./Organ.vue?vue&type=style&index=0&id=4cf5ae88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5ae88",
  null
  
)

export default component.exports